var basepath='./';
export const otherinstruction={
  otherContent:
  '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="otherinstruction">保修范围要求</p>\n' +
  '<div style=\'font-size: 14px;color: #999999;line-height: 25px;\'>'+
  '1.2018年10月1日起购买的，且生产日期为2017年1月1日之后的均可享受以下保修政策；出厂日期为2017年1月1日之前的不享受以下保修政策。\n' +'<br>\n' +
  '2.报修时必须提供正规发票或盖章的销售凭证、收据才可享受保修政策。\n' +'<br>\n' +
  '3.非产品质量原因导致的故障不在保修范围内。\n' +'<br>\n' +
  '4. 如电子保修卡保修期限与保修政策冲突，以保修政策为准。\n' +
    '</div>'
    +
  '<p style=\'font-size:18px;color:#333333;margin-top: 10px;\' id="otherdeadline">保修年限及说明</p>'
  // +
  // '<img src="'+basepath+'static/ridian_period_note.png" style=\'width:100%;\' \/>'
}


// WEBPACK FOOTER //
// ./src/struction/otherinstruction.js